import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {ReservationService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {filterSchedules} from "./filter-schedules.slice";
import store from "../../../store";

interface DeleteScheduleStateParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

export const deleteSchedule =
    (params: DeleteScheduleStateParams) => async (dispatch: Dispatch) => {
      const filters = store.getState().schedules.filterSchedules;
      try {
        dispatch(setLoading(true));
        const response = await ReservationService.cancelReservation(
            params.id,
        );
        if (response.status >= 200 || response.status < 300) {
          dispatch(setSuccess(true));
          dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Booking successfully cancelled!' : 'Rezervimi u anulua me sukses!'));
          if (params.onSuccess) params.onSuccess();
          dispatch(setError(""));
          // @ts-ignore
          dispatch(
              // @ts-ignore
              filterSchedules({
                ...filters,
                page: 0,
              })
          );
        }
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(setLoading(false));
        dispatch(errorMsg(err.data.message));
        if (params.onError) params.onError();
        dispatch(setError(err.data.message));
      }
    };

interface DeleteScheduleSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteScheduleSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "schedules/delete",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
